class Footer extends HTMLElement {
    constructor() {
        super();
        this.bindEvents();
    }

    bindEvents() {
        const accordionTitleEle = this.querySelectorAll('.footer__menu-title');
        accordionTitleEle.forEach((ele) => {
            ele.addEventListener("click", this.toggleAccordion.bind(this));
        })
    }

    toggleAccordion(event: Event) {
        const target = <HTMLElement>event.currentTarget;
        const siblingEle = <HTMLElement>target.nextElementSibling;
        target?.classList.toggle("active");
        siblingEle?.classList.toggle("active");
    }
}


customElements.define("footer-menu", Footer);